import componentActionsMixin from "./component-actions-mixin.js";
import Bus from "../services/bus.js";
import httpMixin from "./http-mixin.js";
import helpWidget from "ireal-vue/widgets/HelpWidget.vue";
import badgeWidget from "ireal-vue/widgets/BadgeWidget.vue";
import toggleWidget from "ireal-vue/widgets/ToggleWidget.vue";

// Handles Common components paterns
export default {
  props: ["config"],
  mixins: [componentActionsMixin, httpMixin],
  components: { helpWidget, badgeWidget, toggleWidget },
  data() {
    return {
      local_config: {},
      collapsed: false,
      classicModal: false,
    };
  },
  created() {
    // Acquire UUID
    this.uuid = this.$store.getters.uuid;
    this.$store.commit("consumeUuid");
    this.local_config = this.config;
  },
  mounted() {
    Bus.$on("ireal-tick", () => {
      this.tick();
    });
  },
  watch: {},
  methods: {
    showModal(val) {
      console.log(val);
      this.$emit("shown");

      return (this.classicModal = val);
    },
    getLayoutByComponent(element) {
      console.log(element.name);
      if (element.name != "div") {
        for (var attribute in element.attributes) {
          console.log(attribute);
        }
      }
      return element;
    },
    getComponentName(element) {
      // Return the name of the component which must render the given element
      return element.type === "element"
        ? `${element.name}Component`
        : "TextComponent";
    },
    getId() {
      // Returns the UUID of this cmponent
      return this.uuid;
    },
    tick() {},
  },
  filters: {
    truncate: function (value, limit) {
      if (value.length > limit) {
        value = value.substring(0, limit - 3) + "...";
      }

      return value;
    },
  },
  computed: {
    attributes() {
      return typeof this.config !== "undefined"
        ? this.config.attributes || {}
        : {};
    },
    clazz() {
      // Définit un ensemble de classes à appliquer sur l'élément racine du composant
      // A partir de l'attribut class pour le style
      // et de l'attribut display pour la visibilité
      let clazz = this.attributes.class || "";
      let display = this.attributes.display;
      if (display === undefined) display = "";
      if (display == "if-started") {
        display = this.$store.state.player.isStarted ? "" : "d-none";
      }
      if (display == "if-not-started") {
        display = this.$store.state.player.started === 0 ? "" : "d-none";
      }
      if (display == "if-finish") {
        display = this.$store.getters.finish === 1 ? "" : "d-none";
      }
      if (display == "if-playing") {
        display = this.$store.getters.isPlaying ? "" : "d-none";
      }
      if (display == "if-not-playing") {
        display = !this.$store.state.player.isPlaying ? "" : "d-none";
      }
      if (display == "if-not-finish") {
        display = this.$store.getters.finish !== 1 ? "" : "d-none";
      }
      clazz = `${clazz} ${display}`;
      return clazz;
    },
    style_hightlight(){
      return "box-shadow:1px 1px 10px 1px #068bea";
    },
    id_selected() {
      return this.attributes.id_selected || undefined;
    },
    inputColor() {
      return "#ff9800";
    },
    model_selected() {
      return this.attributes.model || undefined;
    },
    outputColor() {
      return "#068bea";
    },
    style() {
      return this.attributes.style || "";
    },
    progress() {
      return this.$store.getters.progress;
    },
  },
};
